import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { loadActions } from 'store';
import { FullTable } from 'components';
import { GROUP_TXNS_ACTION_TYPE, groupTransactionBody, groupTransactionHead } from './constants';

export const GroupTransactions = ({}) => {
  const { groupLoadTxns, groupById } = useSelector((state) => ({
    groupLoadTxns: state.loads.groupLoadTxns,
    groupById: state.loads.groupById,

  }));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadActions.getGroupLoadsTxns(groupById?.id));
  }, []);

  return (
    <div>
      <FullTable
        head={groupTransactionHead}
        body={groupTransactionBody}
        loadingType={GROUP_TXNS_ACTION_TYPE}
        list={groupLoadTxns}
        noText={'Transactions'}
      />
    </div>
  );
};